import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { languageByCountryCode } from '@/config/constants';
import { visitorInformationSelector } from '@/state/config';
import styles from './LanguageSelect.module.scss';
export const LanguageSelect = ({ label, required, register, error }) => {
    var _a;
    const { t } = useTranslation();
    const { fields } = useRecoilValue(visitorInformationSelector);
    const field = fields === null || fields === void 0 ? void 0 : fields.find(({ field }) => field === 'language');
    return (_jsx("div", { className: cn(styles.container, {
            [styles.required]: required,
            [styles.error]: error,
        }), children: _jsxs(_Fragment, { children: [_jsx("span", { className: styles.label, children: label }), _jsxs("select", Object.assign({ className: styles.select }, register, { defaultValue: "", children: [_jsx("option", { value: "", disabled: true, children: t('fields.placeholder.language') }), (_a = field === null || field === void 0 ? void 0 : field.languages) === null || _a === void 0 ? void 0 : _a.map((language) => (_jsx("option", { value: language, children: languageByCountryCode[language] }, language)))] })), error && (_jsx("p", { className: styles.errorMessage, children: t('fields.invalid', { field: label }) }))] }) }));
};
